import { render, staticRenderFns } from "./editStation.vue?vue&type=template&id=70720d32&scoped=true&"
import script from "./editStation.vue?vue&type=script&lang=js&"
export * from "./editStation.vue?vue&type=script&lang=js&"
import style0 from "./editStation.vue?vue&type=style&index=0&id=70720d32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70720d32",
  null
  
)

export default component.exports